(function () {
  var FALLBACK_SHOW_AFTER_PX = 600;
  var MOBILE_QUERY = '(max-width: 749px)';
  var DRAWER_SELECTORS = [
    '#sq-cart-drawer',
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer'
  ];
  var QTY_PICKER_SELECTORS = [
    '.sq-bundle',
    '[id^="Quantity-Form-"]'
  ];

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    if (drawer.getAttribute('aria-hidden') === 'false') return true;
    if (drawer.classList.contains('sq-cd--open')) return true;
    if (drawer.classList.contains('active')) return true;
    if (drawer.classList.contains('is-open')) return true;
    if (drawer.hasAttribute('open')) return true;
    return false;
  }

  function findDrawer() {
    for (var i = 0; i < DRAWER_SELECTORS.length; i++) {
      var el = document.querySelector(DRAWER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function findRealForm() {
    var dawnForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (dawnForm) return dawnForm;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    return forms.length ? forms[0] : null;
  }

  function findRealAddButton(form) {
    if (!form) return null;
    if (form.matches('[data-type="add-to-cart-form"]')) {
      var dawnBtn = form.querySelector('button[name="add"]');
      if (dawnBtn) return dawnBtn;
    }
    var candidates = form.querySelectorAll('button[type="submit"]');
    for (var j = 0; j < candidates.length; j++) {
      var candidate = candidates[j];
      if (candidate.className.indexOf('shopify-payment-button') !== -1) continue;
      return candidate;
    }
    return null;
  }

  function findQuantityInput(form) {
    if (form) {
      var scoped = form.querySelector('input[name="quantity"]');
      if (scoped) return scoped;
    }
    return document.querySelector('input[name="quantity"]');
  }

  function findQuantityPicker(form) {
    for (var i = 0; i < QTY_PICKER_SELECTORS.length; i++) {
      var scope = form || document;
      var el = scope.querySelector(QTY_PICKER_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function initStickyAtc(bar) {
    var button = bar.querySelector('[id^="StickyAtcButton-"]');
    var qtyLabel = bar.querySelector('[id^="StickyAtcQty-"]');
    var mediaQuery = window.matchMedia(MOBILE_QUERY);
    var drawer = findDrawer();
    var form = findRealForm();
    var qtyInput = findQuantityInput(form);
    var realButton = findRealAddButton(form);
    var lastQty = null;
    var ticking = false;

    function updateQtyLabel() {
      if (!qtyLabel) return;
      if (!qtyInput) {
        qtyInput = findQuantityInput(form);
        if (!qtyInput) return;
      }
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty < 1) qty = 1;
      if (qty === lastQty) return;
      lastQty = qty;
      qtyLabel.textContent = qty + (qty === 1 ? ' ud.' : ' uds.');
    }

    function realButtonScrolledPast() {
      if (!realButton || !realButton.isConnected) {
        realButton = findRealAddButton(form || findRealForm());
      }
      if (!realButton) {
        return window.scrollY > FALLBACK_SHOW_AFTER_PX;
      }
      var rect = realButton.getBoundingClientRect();
      return rect.bottom < 0;
    }

    function updateVisibility() {
      ticking = false;
      if (!mediaQuery.matches) {
        bar.classList.remove('sticky-atc-mobile--visible');
        return;
      }
      if (realButtonScrolledPast()) {
        bar.classList.add('sticky-atc-mobile--visible');
      } else {
        bar.classList.remove('sticky-atc-mobile--visible');
      }
    }

    function updateDrawerState() {
      if (isDrawerOpen(drawer)) {
        bar.classList.add('sticky-atc-mobile--drawer-open');
      } else {
        bar.classList.remove('sticky-atc-mobile--drawer-open');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateVisibility);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateVisibility);
    }
    updateVisibility();

    if (drawer) {
      updateDrawerState();
      var observer = new MutationObserver(updateDrawerState);
      observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
    } else {
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        drawer = findDrawer();
        if (drawer) {
          clearInterval(poll);
          updateDrawerState();
          var lateObserver = new MutationObserver(updateDrawerState);
          lateObserver.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
        } else if (attempts > 20) {
          clearInterval(poll);
        }
      }, 500);
    }

    updateQtyLabel();
    document.addEventListener('input', function (event) {
      if (event.target && event.target.name === 'quantity') updateQtyLabel();
    });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'quantity') updateQtyLabel();
    });
    document.addEventListener('click', function () {
      window.setTimeout(updateQtyLabel, 50);
    });
    setInterval(updateQtyLabel, 700);

    if (button) {
      button.addEventListener('click', function () {
        var target = findRealAddButton(form);
        if (!target || target.disabled) return;
        target.click();
      });
    }

    if (qtyLabel) {
      qtyLabel.addEventListener('click', function () {
        var picker = findQuantityPicker(form) || qtyInput;
        if (picker && picker.scrollIntoView) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
